import React, {Component} from "react";

const checkIcon = require("../../resources/img/anywhere/check.svg");

interface Props {
    onLunaAccess: () => void;
}

export default class LunaComplete extends Component<Props> {
    render(): JSX.Element {
        return (
            <>
                <h2>How to access Ubisoft+ on Luna</h2>
                <img className="mt-5 mb-4" src={checkIcon} alt="Complete"/>

                <p className="mt-2 mb-sm-5">Your Ubisoft account is linked to Luna</p>

                <button className="btn mb-4" onClick={this.props.onLunaAccess}>
                    Play now
                </button>
            </>
        );
    }
}